import React from "react";
import styled from 'styled-components';
import ColSpacer from "../../../common/styles/ColSpacer";
import Spacer from "../../../common/Spacer";
import BooksitoutImages from "../../../images/BooksitoutImages";
import LoadingBar from '../../../common/LoadingBar';
import breakpoints from "../../../config/Breakpoints";
import RowSpacer from "../../../common/styles/RowSpacer";

const ProfileListItemLoading = () => {
    return (
        <ProfileContainer>
            <div className={'d-flex flex-row align-items-center'}>
                <ProfileImage src={BooksitoutImages.Placeholder.userLoading} alt={'loading'}/>

                <ColSpacer size={15}/>

                <ProfileInfoContainer>
                    <ProfileName><LoadingBar size={10}/></ProfileName>

                    <RowSpacer size={3}/>

                    <ProfileDate>
                        <LoadingBar size={1}/>년
                        {' '}
                        <LoadingBar size={1}/>월
                        {' '}
                        <LoadingBar size={1}/>일
                    </ProfileDate>
                </ProfileInfoContainer>
            </div>

            <Spacer/>

            <BookListContainer>
                {
                    Array.from({length: 7}).map(_ =>
                        <BookCover src={BooksitoutImages.Placeholder.bookCoverLoading}
                                   alt={'placeholder book cover'}/>
                    )
                }
            </BookListContainer>
        </ProfileContainer>
    )
}

const ProfileContainer = styled.div`
    display: flex;

    @media (max-width: ${breakpoints.md}) {
        flex-direction: column;
    }
`

const ProfileImage = styled.img.attrs({
    className: 'rounded',
})`
    width: 50px;
    height: 50px;
    cursor: wait;
`

const ProfileInfoContainer = styled.div`
    max-width: 200px;
`

const ProfileName = styled.h1.attrs({
    className: 'clamp-1-line',
})`
    font-size: 1.5rem;
    font-weight: bold;
    color: var(--text-color);
    margin: 0;
`

const ProfileDate = styled.h1.attrs({
    className: 'clamp-1-line'
})`
    display: flex;
    font-size: 1rem;
    color: var(--sub-text-color);
    margin: 0;
`

const BookListContainer = styled.div.attrs({
    className: 'force-1-line'
})`
    padding-left: 10px;
    color: var(--text-color);

    @media (max-width: ${breakpoints.md}) {
        padding-left: 0;
        padding-top: 10px;
    }
`

const BookCover = styled.img.attrs({
    className: 'rounded',
})`
    height: 60px;
    padding-left: 3px;
    padding-right: 3px;
    cursor: wait;
`

export default ProfileListItemLoading
